import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

/** Libera as rotas /platform/... apenas com sessão de super-admin. */
export const platformAuthGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  return auth.platformSession() ? true : router.createUrlTree(['/login']);
};
